import { getDataExportSourceCapabilitiesQuery } from '@gonfalon/rest-api/queries/usage';
import { useQuery } from '@tanstack/react-query';

import type { DataExportCapabilitiesState } from '../utils/combineDataExportUsage';
import { isDataExportCombinedTabEnabled } from '../utils/getVisibleUsageTabs';

const CAPABILITIES_STALE_TIME_MS = 60_000;

export function useDataExportSourceCapabilities({
  enabled = true,
}: { enabled?: boolean } = {}): DataExportCapabilitiesState {
  const query = useQuery({
    ...getDataExportSourceCapabilitiesQuery({ header: { 'LD-API-Version': 'beta' } }),
    staleTime: CAPABILITIES_STALE_TIME_MS,
    enabled: enabled && isDataExportCombinedTabEnabled(),
  });

  return { data: query.data, isLoading: query.isLoading, isError: query.isError };
}
